exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2LMM5{position:relative}._2LMM5 p{font-weight:300}.MyoeD{width:100%}.MyoeD img{width:inherit}._3bgdL,.HLoiz{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:40px 0}._3bgdL{max-width:1000px;margin:0 auto}.U3tjK{width:40%;margin:5px;padding:20px;border:2px solid}._3T84B{width:33%;padding:5px 1px}._3VtHU{padding:0 25px;width:100%}._2Pkz3{border-color:#e5a826}._2Pkz3 .FDuei{color:#e5a826}.QlKun{border-color:#dcefed}.QlKun .FDuei{color:#dcefed}.FDuei{text-align:center;height:100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2ww7a,.FDuei{font-weight:700;font-size:20px;display:-webkit-box;display:-ms-flexbox;display:flex}._2ww7a{height:80px;color:#dcefed;padding:10px 0}.hDiAn{padding-top:20px}._3Yktb{border:4px solid #dcefed;max-height:200px;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}._3Yktb img{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}@media (max-width:767px){._3bgdL,.HLoiz{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:20px 20px 30px}._3T84B,.FDuei,.U3tjK{width:100%}.FDuei{display:block;height:inherit}._3T84B{padding:20px 10px}._2ww7a{height:60px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3VtHU{padding:0}}._13PA8{width:100%;margin-bottom:30px}._13PA8 img{width:70px;margin:0 auto;display:block}._1VsRn{font-size:22px;font-weight:300;margin-top:30px;padding:0 20px}._2B16w{text-decoration:none}._2B16w,._2B16w:hover{color:#f0ce87}", ""]);

// exports
exports.locals = {
	"rowContainer": "_2LMM5",
	"headerImage": "MyoeD",
	"topCardsContainer": "HLoiz",
	"bottomCardsContainer": "_3bgdL",
	"topCard": "U3tjK",
	"bottomCard": "_3T84B",
	"bottomCardBody": "_3VtHU",
	"topCardOne": "_2Pkz3",
	"topCardTitle": "FDuei",
	"topCardTwo": "QlKun",
	"bottomCardTitle": "_2ww7a",
	"topCardBody": "hDiAn",
	"bottomCardImageWrapper": "_3Yktb",
	"dividerWrapper": "_13PA8",
	"gettingStarted": "_1VsRn",
	"gettingStartedLink": "_2B16w"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/howto/HowTo.css
// module id = 1336
// module chunks = 12